const initializeSwiperCart = () => {
    let selector = document.querySelector('.swiper.free-samples');
    if (selector && !selector.classList.contains('swiper-initialized')) {
        new Swiper('.swiper.free-samples', {
            spaceBetween: 10,
            slidesPerView: 1.2,
            clickable: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            breakpoints: {
                750: {
                    spaceBetween: 10,
                    slidesPerView: 2.4,
                    clickable: true,
                },
            }
        });
    }
}

const updateLocalStorageFromCart = (variantId) => {
    let pumpedProducts = localStorage.getItem('pumpedProducts');
    if(pumpedProducts) {
        pumpedProducts = JSON.parse(pumpedProducts);
        if(pumpedProducts.includes(variantId)) {
            pumpedProducts.splice(pumpedProducts.indexOf(variantId), 1);
            localStorage.setItem('pumpedProducts', JSON.stringify(pumpedProducts));
        }
    }
}
const getSamplesIdsFromCartPage =  () => {
    let samples = document.querySelectorAll('.cart-item.cart-sample .item-variant-id');
    let samplesIds = Array.from(samples).map((sample) => parseInt(sample.value));
    let cartSamples = document.querySelectorAll('cart-sample .add-sample-variant-id');
    let updates = {};

    Array.from(cartSamples).map((cartSample) => {
        if(samplesIds.includes(parseInt(cartSample?.value)))  {
            updates[cartSample?.value] = 0;
        }
    });
    if(Object.keys(updates).length === 0) {
        return false;
    }
    return updates;
}

const getFormDataCart = (items, customElement) => {
    let formData = {};
    formData = {
        updates: items,
    };
    formData['sections'] = customElement.getSectionsToRender().map((section) => section.section);
    formData['sections_url'] =  window.location.pathname;
    return formData;
}
const samplesAlreadyAdded = () => {
    let itemsArr = document.querySelectorAll('.cart-item');
    let freeSamplesArr = document.querySelectorAll('.free-samples__item .add-sample-variant-id');
    let freeSamplesIdsArr = Array.from(freeSamplesArr).map(item => item.value);

    let count = [];
    itemsArr.forEach(item => {
        let itemId = item.querySelector('.item-variant-id').value;
        if (freeSamplesIdsArr.includes(itemId)) {
            count.push(itemId);
        }
    })
    if(count?.length >= 2) {
        return true;
    } return false;
}
function* uniqueIDGenerator(){
    let count = 0;
    while(true){
        yield count++;
    }
}

function NotificationController(freeSamples, topBar) {
    let notificationTemplate = document.querySelector('.top-bar__notification-template').content;
    let notifications = [];
    let uniqueID = uniqueIDGenerator();

    function showSamplingNotification(textContent = '') {
        if (!freeSamples) {
            return;
        }
        if (!topBar.querySelector('.text-shipping.samples')) {
            let htmlEle = generateNotificationElement(textContent, 'samples');
            topBar.append(htmlEle);
            topBar.classList.remove('hidden');
            samplesImg = htmlEle.querySelector('[class*=img-]')
        } else {
            if (textContent != '') {
                topBar.style.display = 'flex';
                notifications.filter((item)=>{return item.type == 'samples'}).forEach(({ele, key})=>{
                    notifications.find((item)=>item.key == key).active = true;

                    ele.querySelector('.first-difference-span').innerHTML = textContent;
                    ele.style.display = 'flex';
                })
            }
        }
    }

    function hideSamplingNotification() {
        notifications.filter((item)=>{return item.type == 'samples'}).forEach(({ele, key})=>{
            notifications.find((item)=>item.key == key).active = false;
            ele.style.display = 'none';
        })
    }
    function disableSamplingNotification() {
        notifications.filter((item)=>{return item.type == 'samples'}).forEach(({ele, key})=>{
            notifications.find((item)=>item.key == key).active = false;
            ele.style.display = '';
            ele.classList.add("disabled");
        })
    }

    function showSamplingSlider() {
        if (freeSamples) {
            freeSamples.style.display = 'block';
            freeSamples.classList.remove("disabled");
        }
    }
    function hideSamplingSlider() {
        if (freeSamples) {
            freeSamples.style.display = 'none';
        }
    }
    function disableSamplingSlider() {
        if (freeSamples) {
            freeSamples.style.display = '';
            freeSamples.classList.add("disabled");
        }
    }

    function showShippingNotification(textContent = '') {
        if (!topBar.querySelector('.text-shipping.shipping')) {
            let htmlEle = generateNotificationElement(textContent,'shipping');
            topBar.append(htmlEle);
            topBar.classList.remove('hidden');
            shippingImg = htmlEle.querySelector('[class*=img-]')
        } else {
            if (textContent != '') {
                topBar.style.display = 'flex';
                notifications.filter((item)=>{return item.type == 'shipping'}).forEach(({ele, key}, index)=>{
                    notifications.find((item)=>item.key == key).active = true;
                    ele.querySelector('.first-difference-span').innerHTML = textContent;
                    ele.style.display = 'flex';
                })
            }
        }
    }

    function hideShippingNotification() {
        notifications.filter((item)=>{return item.type == 'shipping'}).forEach(({ele, key})=>{
            notifications.find((item)=>item.key == key).active = false;
            ele.style.display = 'none';
        })
    }

    function generateNotificationElement(textContent = '', notificationType) {
        let tempEle = notificationTemplate.cloneNode(true).firstElementChild;
        tempEle.classList.add(notificationType?.toLowerCase());
        tempEle.querySelector('.text-shipping').classList.add(notificationType?.toLowerCase());
        let uid = uniqueID.next().value;
        tempEle.dataset.key = uid;
        if (uid = 0) {
            tempEle.classList.add('first');
        }

        tempEle.querySelectorAll('[class^=img-]').forEach((item) => {
            let itemClassNameIncludesType = item.className?.split(' ').some((_class)=>{ return _class.includes(notificationType) });
            if (itemClassNameIncludesType) {
                item.style.display = 'inline-flex';
            } else {
                item.style.display = 'none';
            }
        });  
        tempEle.querySelector('.first-difference-span').innerHTML = textContent;
        notifications.push({ele:tempEle, type:notificationType, active: textContent != '', key: uid});
        return tempEle;
    }

    return {
        showSamplingNotification,
        hideSamplingNotification,
        disableSamplingNotification,
        showSamplingSlider,
        hideSamplingSlider,
        disableSamplingSlider,
        showShippingNotification,
        hideShippingNotification,
        generateNotificationElement
    }
}
window.notificationController = undefined;

const showFreeSamples = () => {
    let itemsCount = 0;
    itemsCount = document.querySelectorAll('.cart-item')?.length;
    let freeSamples = document.querySelector('.free-samples');
    let topBar = document.querySelector('.top-bar-container');
    if(itemsCount > 0) {
        let subtotal = document.querySelector('.totals__subtotal-value')?.innerText;
        subtotal = parseInt(subtotal.replace(/[^0-9]/g, '').split('.')[0]);

        let currencySymbol = document.querySelector('.currency-symbol').value
        let countryCode = document.querySelector('.country-iso-code').value;
        let bottomShipping = document.querySelector('.free-shipping');
        let samplesAdded = samplesAlreadyAdded();

        const qualifiedFreeShippingText = document.querySelector('.qualified-free-shipping').value;
        const bottomShippingTaxesText = document.querySelector('.bottom-shipping-taxes').value;
        const chooseFreeSamplesText = document.querySelector('.choose-free-samples') && document.querySelector('.choose-free-samples').value || "";
        const announcementSpendText = document.querySelector('.announcement-spend').value;
        const announcementFreeShippingText = document.querySelector('.announcement-free-shipping').value;
        const announcementFreeSampleText = document.querySelector('.announcement-free-sample').value;

        // Gift Card Total
        let giftCardTotal = 0;
        const giftCardsElms = document.querySelectorAll('.item-variant-isGiftCard');
        const giftCards = [...giftCardsElms];
        giftCards.forEach((giftCard) => {
            giftCardTotal += Number(giftCard.previousElementSibling.value);
        });

        let refillPouchTotalPrice = Array.from(document.querySelectorAll('.item-variant-isRefillPouch'))
        .map((item)=>{return +item.parentElement.querySelector('.item-variantLine-price').value})
        .reduce((a,b)=>{
            return a + b
        }, 0);

        const totalMinusGiftCards = subtotal - giftCardTotal;

        let showSampling = false;
        let showSamplingSlider = false;
        let showShipping = false;
        let notificationPositions = [];

        let shippingDataObj = window.shippingDataObj && Object.entries(window.shippingDataObj).length ? window.shippingDataObj : {
            40: ['gb'],
            50: ['ie', 'at', 'nl', 'de', 'fr', 'be', 'pl', 'lu', 'sk', 'cz', 'dk', 'us'],
            80: ['hr', 'ee', 'es', 'it', 'hu', 'lv', 'lt', 'no', 'pt', 'ro', 'rs', 'si', 'se']
        };
        let shippingDataEntries = Object.entries(shippingDataObj);
        let shippingThresholdIndex = shippingDataEntries.findIndex((code)=>{ return code[1].includes(countryCode.toLowerCase()) });
        let shippingAmountLeft = -1;

        if (shippingThresholdIndex > -1) {
            let shippingthresholdValue = +shippingDataEntries[shippingThresholdIndex][0] * 100;
            notificationPositions.push({type:'shipping', value:shippingthresholdValue})
            shippingAmountLeft = (shippingthresholdValue - totalMinusGiftCards);
            if (shippingAmountLeft > 0) {
                showShipping = true;
            }
        }

        let samplesDataObj = {
            55: ['£'],
            65: ['€']
        }

        let samplesDataEntries = Object.entries(samplesDataObj);
        let samplesThresholdIndex = samplesDataEntries.findIndex((code)=>{ return code[1].includes(currencySymbol.toLowerCase()) });
        let samplesAmountLeft = -1;

        if (samplesThresholdIndex > -1) {
            let samplesthresholdValue = +samplesDataEntries[samplesThresholdIndex][0] * 100;
            notificationPositions.push({type:'samples', value:samplesthresholdValue})
            samplesAmountLeft = (samplesthresholdValue - (totalMinusGiftCards - refillPouchTotalPrice));
            showSampling = true;
            if (samplesAmountLeft <= 0 && !samplesAdded) {
                showSamplingSlider = true;
            }
            if (samplesAdded) {
                showSampling = false;
            }
        }

        notificationPositions = notificationPositions.sort((a,b)=>Number(a.value)>Number(b.value)?1:-1);
        notificationController = notificationController || NotificationController(freeSamples, topBar);

        if (!showShipping && !showSampling) {
            //hide all
            notificationController.hideShippingNotification();
            notificationController.hideSamplingNotification();
            notificationController.hideSamplingSlider();
            topBar.style.display = 'none';
        } else {
            notificationPositions.forEach((item)=>{
                if (item.type == 'samples') {
                    notificationController.showSamplingNotification();
                    if (showSampling) {
                        if (showSamplingSlider) {
                            notificationController.showSamplingSlider();
                            // show sample slider
                            notificationController.showSamplingNotification(`${chooseFreeSamplesText}`)
                            initializeSwiperCart();

                            // check if free sample is already added
                            let itemsArr = document.querySelectorAll('.cart-item');
                            let freeSamplesArr = document.querySelectorAll('.free-samples__item .add-sample-variant-id');

                            let freeSamplesIdsArr = Array.from(freeSamplesArr).map(item => item.value);
                            let count = [];
                            itemsArr.forEach(item => {
                                let itemId = item.querySelector('.item-variant-id').value;
                                if (freeSamplesIdsArr.includes(itemId)) {
                                    count.push(itemId);
                                    document.querySelector(`.free-samples__item input[value="${itemId}"]`).parentNode.parentNode.style.display = 'none';
                                    document.querySelector('.swiper.free-samples')?.swiper?.update(true);
                                }
                            })
                            freeSamplesArr.forEach(item => {
                                if (!count.includes(item.value)) {
                                    item.parentNode.parentNode.style.display = 'block';
                                }
                            })
                            if (count.length >= 2) {
                                // topBar.style.display = 'none';
                            } else {
                                // topBar.style.display = 'block';
                                topBar.querySelectorAll('.top-bar').forEach((item) => {
                                  if (item.classList?.contains('samples')) {
                                    item.style.order = 2;
                                  } else {
                                    item.style.order = 1;
                                  }
                                });
                                document.querySelector('.swiper.free-samples')?.swiper?.update(true);
                                topBar.querySelector('.top-bar.samples')?.classList.remove("disabled");
                            }
                        } else {
                            if (samplesAmountLeft > 0) {
                                initializeSwiperCart();
                                notificationController.disableSamplingNotification()
                            } else {
                                notificationController.hideSamplingSlider()
                            }
                            let formatMoney = (samplesAmountLeft.toFixed(2) * .01).toFixed(2);
                            notificationController.showSamplingNotification(`${announcementSpendText} ${currencySymbol}${formatMoney} ${announcementFreeSampleText}`);
                        }
                    } else {
                        if (samplesAmountLeft > 0) {
                            notificationController.disabledSamplingNotification()
                        } else {
                            notificationController.hideSamplingNotification()
                        }
                    }
                }
                if (item.type == 'shipping') {
                    notificationController.showShippingNotification();
                    if (showShipping) {
                        let formatMoney = (shippingAmountLeft.toFixed(2) * .01).toFixed(2);
                        let notificationText = `${announcementSpendText} ${currencySymbol}${formatMoney} ${announcementFreeShippingText}`
                        notificationController.showShippingNotification(notificationText);
                    } else {
                        notificationController.hideShippingNotification()
                    }
                }
            });
            if (!showSamplingSlider) {
                if (samplesAmountLeft > 0) {
                    notificationController.disableSamplingSlider();
                } else {
                    notificationController.hideSamplingSlider();
                }
            }
        }

        /* Subtotal */
        if(shippingAmountLeft <= 0 && shippingThresholdIndex != -1) {
            bottomShipping.innerHTML = `${qualifiedFreeShippingText}`;
        } else {
            bottomShipping.innerHTML = `${bottomShippingTaxesText}`;
        }


    } else {
        if (freeSamples) {
            freeSamples.style.display = 'none';
        }
        topBar.style.display = 'none';
    }
}

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            let variantId = this?.closest('.cart-item')?.querySelector('.item-variant-id')?.value;
            if(variantId.length > 0) {
                cartItems.updateQuantity(this.dataset.index, 0, null ,variantId);
            } else {
                cartItems.updateQuantity(this.dataset.index, 0);
            }
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        this.subtotal = document.querySelector('.totals__subtotal-value');

        showFreeSamples();

        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        let variantId = event.target?.closest('.cart-item')?.querySelector('.item-variant-id')?.value;
        if(variantId.length > 0) {
            this.updateQuantity(event.target.dataset.index, event.target.value, null, variantId);
        } else {
            this.updateQuantity(event.target.dataset.index, event.target.value);
        }
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart',
                section: document.getElementById('main-cart').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart').dataset.id,
                selector: '.cart__footer .js-contents',
            },
            {
                id: 'cart-title',
                section: document.getElementById('main-cart').dataset.id,
                selector: '.h2 .items-count',
            }
        ];
    }

    updateQuantity(line, quantity, name, variantId ) {
        this.enableLoading(line);
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
            return response.text();
        })
        .then((state) => {
            const parsedState = JSON.parse(state);
            this.updateLiveRegions(line, parsedState.item_count);

            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');
            const cartWrapper = document.querySelector('main .cart-wrapper');
            const cartItems = document.querySelector('cart-items');

            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartWrapper) cartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartItems) cartItems.classList.toggle('empty-cart-items', parsedState.item_count === 0);

            this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                if(section.selector === '.cart__footer .js-contents') {
                    let subtotal = this.getSectionInnerHTML(parsedState.sections[section.section], '.totals__subtotal-value');
                    let btn_total = document.querySelector('.cart__ctas .btn-total');
                    if(btn_total) {
                        btn_total.innerHTML = subtotal;
                    }
                }
                if(section && section.section === 'cart-icon-bubble') {
                    let iconBubble =  this.getSectionInnerHTML(parsedState.sections[section.section], '.shopify-section .cart-count-bubble');
                    let mobileIconBubble = document.querySelector('.header__icons.hide-for-xlarge .cart-count-bubble');
                    if(iconBubble && mobileIconBubble) mobileIconBubble.innerHTML = iconBubble;
                }
                elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

            }));
            const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
            }
            showFreeSamples();
            this.disableLoading();

            let subtotal = document.querySelector('.totals__subtotal-value')?.innerText;

            // Gift Card exist? 
            let giftCardTotal = 0;
            const giftCardsElms = document.querySelectorAll('.item-variant-isGiftCard');
            const giftCards = [...giftCardsElms];
            giftCards.forEach((giftCard) => {
                giftCardTotal += Number(giftCard.previousElementSibling.value);
            });
            let refillPouchTotalPrice = Array.from(document.querySelectorAll('.item-variant-isRefillPouch'))
            .map((item)=>{return +item.parentElement.querySelector('.item-variantLine-price').value})
            .reduce((a,b)=>{
            return a + b
            }, 0);
            subtotal = parseInt(subtotal.replace(/[^0-9]/g, '').split('.')[0]);

            let currencySymbol = document.querySelector('.currency-symbol').value;
            let samplesDataObj = {
                55: ['£'],
                65: ['€']
            }
            let samplesDataEntries = Object.entries(samplesDataObj);
            let samplesThresholdIndex = samplesDataEntries.findIndex((code)=>{ return code[1].includes(currencySymbol.toLowerCase()) });
            let cartSampleBreakpoint = document.querySelector('.free-samples-input').value * 100;
    
            if (samplesThresholdIndex > -1) {
                cartSampleBreakpoint = +samplesDataEntries[samplesThresholdIndex][0] * 100;
            }

            if((subtotal - giftCardTotal) - refillPouchTotalPrice < cartSampleBreakpoint ) {
                const sampleIdsFromCart = getSamplesIdsFromCartPage();
                if(sampleIdsFromCart) {
                    let formDataNested = getFormDataCart(sampleIdsFromCart, this);
                    fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(formDataNested),
                    }).then((response) => {
                        return response.text();
                    }).then((response) => {
                        const parsedState = JSON.parse(response);

                        this.classList.toggle('is-empty', parsedState.item_count === 0);
                        const cartDrawerWrapper = document.querySelector('cart-drawer');
                        const cartFooter = document.getElementById('main-cart-footer');
                        const cartWrapper = document.querySelector('main .cart-wrapper');
                        const cartItems = document.querySelector('cart-items');

                        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                        if (cartWrapper) cartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                        if (cartItems) cartItems.classList.toggle('empty-cart-items', parsedState.item_count === 0);


                        this.getSectionsToRender().forEach((section => {
                            const elementToReplace =
                            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                            elementToReplace.innerHTML =
                            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                            if(section && section.section === 'cart-icon-bubble') {
                                let iconBubble =  this.getSectionInnerHTML(parsedState.sections[section.section], '.shopify-section .cart-count-bubble');
                                let mobileIconBubble = document.querySelector('.header__icons.hide-for-xlarge .cart-count-bubble');
                                if(iconBubble && mobileIconBubble) mobileIconBubble.innerHTML = iconBubble;
                            }
                            showFreeSamples();
                        }));
                    }).catch((error) => {
                        console.error("Error:", error);
                    });
                }
            }

            if(parseInt(quantity) === 0 && variantId !== null) {
                updateLocalStorageFromCart(variantId);
            }
        }).catch((err) => {
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            errors.textContent = window.cartStrings.error;
            this.disableLoading();
        });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            if(lineItemError?.querySelector('.cart-item__error-text')) {
                lineItemError
                .querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace(
                    '[quantity]',
                    quantityElement.value
                    );
                }
            }

            this.currentItemCount = itemCount;
            this.lineItemStatusElement.setAttribute('aria-hidden', true);

            const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
            cartStatus.setAttribute('aria-hidden', false);

            setTimeout(() => {
                cartStatus.setAttribute('aria-hidden', true);
            }, 1000);
        }

        getSectionInnerHTML(html, selector) {
            return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
        }

        enableLoading(line) {
            const mainCartItems = document.getElementById('main-cart') || document.getElementById('CartDrawer-CartItems');
            mainCartItems.classList.add('cart__items--disabled');

            const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
            const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

            [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

            document.activeElement.blur();
            this.lineItemStatusElement.setAttribute('aria-hidden', false);
        }

        disableLoading() {
            const mainCartItems = document.getElementById('main-cart') || document.getElementById('CartDrawer-CartItems');
            mainCartItems.classList.remove('cart__items--disabled');
        }
    }

    customElements.define('cart-items', CartItems);

    if (!customElements.get('cart-note')) {
        customElements.define('cart-note', class CartNote extends HTMLElement {
            constructor() {
                super();

                this.addEventListener('change', debounce((event) => {
                    const body = JSON.stringify({ note: event.target.value });
                    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
                }, 300))
            }
        });
    }

    class CartSample extends HTMLElement {
        constructor() {
            super();
            this.sampleAdd = this.querySelector('.add-sample-cart');

            this?.sampleAdd?.addEventListener('click', (event) => {
                let variantId = this.querySelector('.add-sample-variant-id')?.value;
                let formData = {};
                let items = [
                    {
                        id: variantId,
                        quantity: 1
                    }
                ]
                formData = {
                    items: items,
                };
                formData['sections'] = this.getSectionsToRender().map((section) => section.section);
                formData['sections_url'] =  window.location.pathname;

                fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }).then((response) => {
                    return response.text();
                }).then((response) => {
                    const parsedState = JSON.parse(response);
                    this.getSectionsToRender().forEach((section => {
                        const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                        if(section.selector === '.cart__footer .js-contents') {
                            let subtotal = this.getSectionInnerHTML(parsedState.sections[section.section], '.totals__subtotal-value');
                            let btn_total = document.querySelector('.cart__ctas .btn-total');
                            if(btn_total) {
                                btn_total.innerHTML = subtotal;
                            }
                        }
                        if(section && section.section === 'cart-icon-bubble') {
                            let iconBubble =  this.getSectionInnerHTML(parsedState.sections[section.section], '.shopify-section .cart-count-bubble');
                            let mobileIconBubble = document.querySelector('.header__icons.hide-for-xlarge .cart-count-bubble');
                            if(iconBubble && mobileIconBubble) mobileIconBubble.innerHTML = iconBubble;
                        }
                        elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                    }));
                    showFreeSamples();
                }).catch((error) => {
                    console.error("Error:", error);
                });
            });
        }

        getSectionsToRender() {
            return [
                {
                    id: 'main-cart',
                    section: document.getElementById('main-cart').dataset.id,
                    selector: '.js-contents',
                },
                {
                    id: 'cart-icon-bubble',
                    section: 'cart-icon-bubble',
                    selector: '.shopify-section'
                },
                {
                    id: 'cart-live-region-text',
                    section: 'cart-live-region-text',
                    selector: '.shopify-section'
                },
                {
                    id: 'main-cart-footer',
                    section: document.getElementById('main-cart').dataset.id,
                    selector: '.cart__footer .js-contents',
                },
                {
                    id: 'cart-title',
                    section: document.getElementById('main-cart').dataset.id,
                    selector: '.h2 .items-count',
                }
            ];
        }

        getSectionInnerHTML(html, selector) {
            return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
        }

    }

    customElements.define('cart-sample', CartSample);
